import React, { useState, useEffect } from "react";
import Commonheader from "./Commonheader";
import useAxios from "../hooks/useAxios";
import {
  Modal,
  Form,
  Input,
  Select,
  InputNumber,
  Button,
  Row,
  Col,
} from "antd";
import { EditOutlined, DeleteFilled, PlusOutlined } from "@ant-design/icons";
import { defaultConfig, ConfigForm } from "./ExecuteServiceConfig";

function UpdateExecuteServiceConfig(props) {
  const [loading, sendRequest] = useAxios();
  const [isErrOpen, setisErrOpen] = useState(false);
  const [api_error_message, setapi_error_message] = useState();
  const [config, setConfig] = useState();
  const [config_id, setConfigId] = useState(props.location.state.config_id);
  const [refreshConfig, setRefreshConfig] = useState(true);

  useEffect(() => {
    let apitoken = localStorage.getItem("api_token");

    sendRequest(
      {
        url: `${process.env.REACT_APP_BASE_URL}/config/executeservice/${config_id}`,
        method: "GET",
        headers: {
          "api-token": apitoken,
        },
      },
      (response) => {
        const _config = {
          destination_status: response.destination_status,
          db_name: response.db_config.split(".")[0],
          collection_name: response.db_config.split(".")[1],
          input_key: response.query_config.split("|")[0],
          derived_key: response.query_config.split("|")[1],
          status: response.status,
          uri: response.uri,
          type: response.query_config.split("|")[2],
        };
        console.log("_config", _config);
        setConfig(_config);
      }
    );
  }, [refreshConfig]);

  const setError = (error_message) => {
    setisErrOpen(true);
    setapi_error_message(error_message);
  };
  const updateConfig = (e) => {
    const allFieldsFilled = Object.values(config).every(
      (value) => value !== ""
    );

    if (!allFieldsFilled) {
      setError("All fields are mandatory!");
      return;
    }

    const _config = {
      db_config: `${config.db_name}.${config.collection_name}`,
      destination_status: config.destination_status
        ? config.destination_status
        : null,
      query_config: `${config.input_key}|${config.derived_key}|${config.type}`,
      status: config.status,
      uri: config.uri,
      id: config_id,
    };

    console.log("Update request", _config);
    let apitoken = localStorage.getItem("api_token");

    sendRequest(
      {
        url: `${process.env.REACT_APP_BASE_URL}/config/executeservice/${config_id}/update`,
        method: "POST",
        headers: {
          "api-token": apitoken,
          "Content-Type": "application/json",
        },
        data: _config,
      },
      (response) => {
        console.log("Updated Response", response);
        if (response.error) {
          setError(response.error);
          return;
        }
        setRefreshConfig(!refreshConfig);
      }
    );
  };

  return (
    <div className="container">
      <Commonheader pagetitle={"View List"} props={props} />
      {loading && (
        <div class="load-4">
          <div class="ring-1"></div>
        </div>
      )}
      <div
        className={
          isErrOpen
            ? "modal fade show d-block mymodal"
            : "modal fade bd-example-modal-sm"
        }
        tabIndex="-1"
        role="dialog"
        aria-labelledby="myLargeModalLabel"
        aria-hidden="true"
        id="confirm-box"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content cdb-confirm-box col-sm-12">
            <button
              type="button"
              className="close text-right"
              data-dismiss="modal"
              aria-label="Close"
              onClick={() => {
                setisErrOpen(false);
                window.location.reload();
              }}
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <p className="popuperrtext">{api_error_message}</p>
          </div>
        </div>
      </div>
      {config && (
        <ConfigForm
          initialConfig={config}
          setConfig={(config) => {
            setConfig(config);
          }}
        />
      )}
      <button className="btn btn-primary" onClick={updateConfig}>
        Save
      </button>
    </div>
  );
}

export default UpdateExecuteServiceConfig;
